import { GameCommunicationBaseSender } from '@pp/core/src/controllers/gameCommunication/senders/GameCommunicationBaseSender';
import type { GameCommunicationSenderType } from '@pp/core/src/services/gameCommunication/types';

import { GameKeepAliveSchedulerService } from '../../../services/gameKeepAliveSchedulerService';
import { GameStore } from '../../../store/GameStore';

export class GameCommunicationKeepAliveSender extends GameCommunicationBaseSender {
  name = 'crashPing';
  private schedulerService: GameKeepAliveSchedulerService;
  constructor() {
    super();
    this.schedulerService = new GameKeepAliveSchedulerService(() => {
      this.dispatch(true);
    });
  }

  send(_: boolean, store: GameStore, sender: GameCommunicationSenderType): void {
    const state = store.getState();
    const gameChannel = state.gameState.gameChannel;
    const userId = state.config.playerConfig?.userId;
    if (gameChannel && userId) {
      let message = '';
      message += `<crashPing/>`;
      sender?.(message);
    }
  }
  stop(): void {
    this.schedulerService.stop();
  }

  refreshSchedulerState(isGamePaused: boolean, isHighflyerPT: boolean): void {
    this.schedulerService.updateSchedulerState(isGamePaused, isHighflyerPT);
  }
}
